module.exports = __webpack_public_path__ + "assets/logo-crafty-component.6183f9f9.svg";